import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { ICON } from 'resources/constants';
import { useText } from 'common/hooks';

import {
  Container,
  Question,
  NpsWrapper,
  SmallText,
  NpsButtons,
  HiddenWrapper,
  TextArea,
  ButtonsWrapper,
  CancelButton,
  SendButton,
} from './elements';

const deps = {
  npsForm: state.challenge.info.npsForm,
  isSendingFeedback: state.challenge.info.isSendingFeedback,
  showFeedbackTextArea: state.challenge.info.showFeedbackTextArea,
  npsScoreChanged: sequences`challenge.info.npsScoreChanged`,
  npsCommentChanged: sequences`challenge.info.npsCommentChanged`,
  setNpsScore: sequences`challenge.info.setNpsScore`,
  dismissNps: sequences`challenge.info.dismissNps`,
};

export function Form({
  npsForm,
  isSendingFeedback,
  showFeedbackTextArea,
  npsScoreChanged,
  npsCommentChanged,
  setNpsScore,
  dismissNps,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Container>
      <Question>{t('challenge.NpsModal.likely_to_recommend')}</Question>
      <NpsWrapper>
        <SmallText>{t('challenge.NpsModal.not_likely')}</SmallText>
        <NpsButtons
          numberSelected={npsForm.score}
          onClick={number => npsScoreChanged({ score: number })}
        />
        <SmallText>{t('challenge.NpsModal.very_likely')}</SmallText>
      </NpsWrapper>
      <HiddenWrapper display={showFeedbackTextArea}>
        <Question>{t('challenge.NpsModal.important_reason')}</Question>
        <TextArea
          onChange={event => npsCommentChanged({ comment: event.target.value })}
          value={npsForm.comment}
          placeholder={t('challenge.NpsModal.share_thoughts')}
          icon={ICON.modeEdit}
        />
        <ButtonsWrapper>
          <CancelButton
            onClick={() => dismissNps()}
            disabled={isSendingFeedback}
          >
            {t('challenge.NpsModal.cancel')}
          </CancelButton>
          <SendButton
            onClick={() => setNpsScore()}
            disabled={isSendingFeedback}
          >
            {t('challenge.NpsModal.send_feedback')}
          </SendButton>
        </ButtonsWrapper>
      </HiddenWrapper>
    </Container>
  );
}

export default connect(deps, Form);
